import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { Transfer, Row, Col, Button, Space, Popconfirm, message } from "antd";
import { CardElement } from "../../components/Common";
import BulkReportDeleteTopBar from "../../components/Report/BulkReportDeleteTopBar";
import {
  useGetProjectHotelReports,
  useReportDeleteHotelReport,
} from "../../hooks";

const BulkReportDelete = () => {
  const [hmg, setHmg] = useState();
  const [project, setProject] = useState();
  const [pms, setPMS] = useState();
  const [hotel, setHotel] = useState();
  const [targetKeys, setTargetKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);

  const setHmgRef = useCallback((list) => {
    if (list?.length === 1) setHmg(list[0]._id);
  }, []);
  const setProjectRef = useCallback((list) => {
    if (list?.length === 1) setProject(list[0]._id);
  }, []);
  const setPMSRef = useCallback((list) => {
    if (list?.length === 1) setPMS(list[0]._id);
  }, []);
  const setHotelListRef = useCallback((list) => {
    if (list?.length === 1) setHotel(list[0]._id);
  }, []);

  useEffect(() => {
    setTargetKeys([]);
    setSelectedKeys([]);
  }, [hotel]);

  const {
    data: hotelReports,
    refetch: retrieveHotelReports,
    isLoading: isLoadingHotelReports,
  } = useGetProjectHotelReports(project, hotel, {
    enabled: false,
    select: (data) =>
      data.map((el) => {
        return {
          key: el._id,
          _id: el._id,
          ReportName: el.ReportName,
        };
      }),
  });

  const { mutate: triggerDeleteReports, isLoading: isDeletingReports } =
    useReportDeleteHotelReport({
      onSuccess: () => {
        message.success("Report(s) removed successfully");
      },
      onError: (error) => {
        message.error(error.response?.data?.message ?? "Server Error");
      },
      onSettled: () => {
        setTargetKeys([]);
        setSelectedKeys([]);
        retrieveHotelReports();
      },
    });

  const onChange = (nextTargetKeys, direction, moveKeys) => {
    setTargetKeys(nextTargetKeys);
  };

  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const deleteReports = async () => {
    triggerDeleteReports({
      hotelId: hotel,
      reportIds: targetKeys,
    });
  };

  return (
    <CardElement title="Bulk Report Delete">
      <BulkReportDeleteTopBar
        hmg={hmg}
        setHmg={setHmg}
        setHmgRef={setHmgRef}
        project={project}
        setProject={setProject}
        setProjectRef={setProjectRef}
        pms={pms}
        setPMS={setPMS}
        setPMSRef={setPMSRef}
        hotel={hotel}
        setHotel={setHotel}
        setHotelListRef={setHotelListRef}
        dataRetrievalFn={retrieveHotelReports}
        isLoading={isLoadingHotelReports}
      />
      <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
        <Col span="24">
          <Space
            direction="horizontal"
            style={{ width: "100%", justifyContent: "center" }}
          >
            <Transfer
              justify="center"
              listStyle={{
                width: 300,
                height: 300,
              }}
              dataSource={hotelReports ?? []}
              titles={["Available", "Delete"]}
              showSearch
              targetKeys={targetKeys}
              selectedKeys={selectedKeys}
              onChange={onChange}
              onSelectChange={onSelectChange}
              render={(item) => item.ReportName}
            />
          </Space>
        </Col>
        {targetKeys.length > 0 && (
          <Col span="24">
            <Space
              direction="horizontal"
              style={{
                width: "100%",
                justifyContent: "center",
              }}
            >
              <Popconfirm title="Sure to delete?" onConfirm={deleteReports}>
                <Button
                  justify="center"
                  type="primary"
                  loading={isDeletingReports}
                >
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          </Col>
        )}
      </Row>
    </CardElement>
  );
};

export default BulkReportDelete;
